import { render, staticRenderFns } from "./OrdersDetailList.vue?vue&type=template&id=90d98a40"
import script from "./OrdersDetailList.vue?vue&type=script&lang=js"
export * from "./OrdersDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports